import { Button, Card, CardBody, CardHeader, Center, Container, FormControl, Grid, Heading, Stack } from '@chakra-ui/react';
import { Input } from '@chakra-ui/react'
import { useState } from 'react';
import usePageTitle from '../../utils/pageTitle';

const AddBankPage = () => {

    const [bank, setBank] = useState<AddBank>({
        code: '',
        name: ''
    })

    usePageTitle("Crear Banco")


    const handleChange = (event: { target: HTMLInputElement | HTMLSelectElement }) => {

        setBank({ ...bank, [event.target.name]: event.target.value })
    }

    return (
        <Grid minHeight="100vh">
            <Center>
                <Container>
                    <Card>
                        <CardHeader>
                            <Heading size='md'>
                                <Center>
                                    Crear Banco
                                </Center>
                            </Heading>
                        </CardHeader>
                        <CardBody>
                            <Stack spacing={3}>
                                <form>
                                    <FormControl>
                                        <Input placeholder='Codigo' name="code" onChange={handleChange} />
                                        <Input placeholder='Nombre' name="name" onChange={handleChange} />
                                        <Button colorScheme='teal' variant='outline' type='submit'>Guardar</Button>
                                    </FormControl>
                                </form>
                            </Stack>
                        </CardBody>
                    </Card>
                </Container>
            </Center>
        </Grid>
    );
}

export default AddBankPage;
